var _defs, _g, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.26;}.cls-2{fill:#f58000;}.cls-3{fill:#1bab59;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.63,22.06H71.19c-29.68,0-53.81,26.15-53.81,58.29v236c0,22.32,24.39,41.74,41.43,51.54V97.47A21.22,21.22,0,0,1,80,76.26H488C478.6,59.1,461.34,22.06,441.63,22.06Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,484a29.12,29.12,0,0,1-25.46-14.69l-52.75-91.39H54.58c-28.53,0-51.74-25.33-51.74-56.47v-249C2.84,41.31,26.05,16,54.58,16H445.42c28.53,0,51.74,25.33,51.74,56.46v249c0,31.14-23.21,56.47-51.74,56.47H328.21l-52.76,91.39A29.09,29.09,0,0,1,250,484Zm-6.3-25.79a7.24,7.24,0,0,0,12.63-.07l58-100.39H445.42c17.4,0,31.56-16.28,31.56-36.3v-249c0-20-14.16-36.28-31.56-36.28H54.58C37.18,36.16,23,52.43,23,72.44v249c0,20,14.16,36.3,31.56,36.3H185.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "326.97 133.94 219.65 241.26 173.03 194.64 149.72 217.94 219.65 287.88 350.28 157.25 326.97 133.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderCheckIcon);
export default __webpack_public_path__ + "static/media/border-check-icon.af4fea7d2b33d040678a3d1796384fd9.svg";
export { ForwardRef as ReactComponent };